import './css.js';

async function init() {
    $(function() {
        let selectHotel$ = $('#select-hotel');
        let backPrevPage$ = $('#back-prev-page');
        if (typeof selectHotel$ !== 'undefined') {
            selectHotel$.change(function(event){
                let hotelId = $(this).val();
                window.location = urlPrefix + '/' + hotelId;
            });
        }
        if (typeof backPrevPage$ !== 'undefined') {
            backPrevPage$.click(function (event){
                history.back();
            });
        }
    })
}

init();


// WEBPACK FOOTER //
// ./webpack/common/main.js